<template>
  <div class="w-full flex flex-row border-grey-100 rounded-md border-2 pt-2 pb-3 px-3 mt-1">
      <div class="grow grid grid-cols-2 gap-x-7 gap-y-2">
        <ValidationProvider rules="required|nameCheck|max:64" name="contact name" v-slot="{ errors }">
          <TextField 
            v-model="values.name" 
            @input="updateValue('name', values.name)" 
            :placeholder="'Contact\'s Name'">
          </TextField>
          <span
            class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
            name="error-text">
            {{ errors[0] }}
          </span>
        </ValidationProvider>
        <ValidationProvider rules="max:32" name="contact relationship" v-slot="{ errors }">
          <TextField
            v-model="values.relationship"
            @input="updateValue('relationship', values.relationship)"
            :placeholder="'Relationship to student'">
          </TextField>
          <span
            class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
            name="error-text">
            {{ errors[0] }}
          </span>
        </ValidationProvider>
        <ValidationProvider rules="emailCheck" name="contact email" v-slot="{ errors }">
          <TextField 
            v-model="values.email" 
            @input="updateValue('email', values.email)" 
            :type="'email'" 
            :placeholder="'Contact\'s email address'">
          </TextField>
          <span
            class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
            name="error-text">
            {{ errors[0] }}
          </span>
        </ValidationProvider>
        <ValidationProvider rules="required|phoneCheck" name="contact phone number" v-slot="{ errors }">
          <TextField 
            v-model="values.phone" 
            @input="updateValue('phone', values.phone)"
            :mask="'(###) ###-####'"
            :type="'tel'" 
            :placeholder="'Contact\'s Phone Number'">
          </TextField>
          <span
            class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
            name="error-text">
            {{ errors[0] }}
          </span>
        </ValidationProvider>
      </div>
      <button 
        type="button" 
        class="basis-1 ml-3 my-auto " 
        @mouseover="hovering = true" 
        @mouseleave="hovering = false" 
        @click="onClick()">
        <svg v-if="!hovering" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#d1d5db" class="w-6 h-6" >
          <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm3 10.5a.75.75 0 000-1.5H9a.75.75 0 000 1.5h6z" clip-rule="evenodd" />
        </svg>
        <svg v-if="hovering" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#dc2626" class="w-6 h-6">
          <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-1.72 6.97a.75.75 0 10-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 101.06 1.06L12 13.06l1.72 1.72a.75.75 0 101.06-1.06L13.06 12l1.72-1.72a.75.75 0 10-1.06-1.06L12 10.94l-1.72-1.72z" clip-rule="evenodd" />
        </svg>
      </button>
      
    </div>
</template>

<script>

import TextField from '../formComponents/TextField.vue'
import cloneDeep from 'clone-deep'


export default {
  data() {
    return {
      hovering: false,
      values: {name: '', relationship: '', email: '', phone: ''}
    }
  },
  props: {
    click: Function,
    disabled: Boolean,
    defaultValues: undefined,
    itemKey: undefined,
  },
  methods: {
    /*phoneFormat(){
      //return /^[(][0-9]{3}[)][\s][0-9]{3}[-][0-9]{4}$/im // (###) ###-#### format
      return /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im
    },*/
    getFormat(){
      return /[`!@#$%^&*_+=[\]{};:"\\|<>/?~]/
    },
    updateValue(key, value) {
      this.$emit('input', { ...this.values, [key]: value });
    },
    onClick() {
      this.$emit('remove');
    },
    setDefaultData() {
      this.values = this.defaultValues ? cloneDeep(this.defaultValues[0]) : {name: '', relationship: '', email: '', phone: ''}
    }
  },
  mounted() {
    this.setDefaultData();
  },
  watch: {
    defaultValues() {
      this.setDefaultData()
    },
  },
  computed: {
    models: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
  },
  components: { TextField }
}
</script>